import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { AssociateService } from '../../../associate/shared/services/associate.service';
import { StaticValueService } from '../../services/static-value.service';

@Component({
  selector: 'app-talent-management-filter',
  templateUrl: './talent-management-filter.component.html',
  styleUrls: ['./talent-management-filter.component.css']
})
export class TalentManagementFilterComponent implements OnInit {
  public countries: any;
  public staticDDList: any;
  public country= '';
  public role = '';
  public mobility = '';
  public gender = '';

  constructor(public dialogRef: MatDialogRef<TalentManagementFilterComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public associateService: AssociateService,
    public staticService: StaticValueService) { }

  ngOnInit() {
    this.staticDDList = this.staticService.staticData.staticDD;
    this.associateService.getDistinctAssociateCountries().subscribe(data => {
      this.countries = data;
  }, error => {});
  }
  proceed() {
    this.dialogRef.close({
      'country': this.country,
      'role': this.role,
      'mobility': this.mobility,
      'gender': this.gender
    });
  }
  cancel() {
    this.dialogRef.close('Cancel');
  }
}
